export default {
  h7: {
    toDeclare: 'toDeclare',
    declaring: 'declaring',
    rejected: 'rejected',
    declared: 'declared',
    accepted: 'accepted',
    checking: 'checking',
    release: 'release',
    inControl: 'In Control',
    status: 'Status',
    shippingRef: 'Shipping Ref.',
    lateDecl: 'Last Decl.',
    trackingNo: 'Tracking No.',
    lrn: 'LRN',
    mrn: 'MRN',
    all: 'All',
    reject: 'Reject',
    gotIt: 'Got it',
    record: 'Record',
    shippingReference: 'Shipping Reference',
    lrnLabel: 'LRN',
    correlationId: 'Correlation ID',
    userId: 'User Id'
  },
  declaration: {
    detail: 'Detail',
    viewRecord: 'View Record',
    success: 'Success TODO',
    trackingNumber: 'Tracking Number:',
    latestDeclarationTime: 'Latest declaration time:',
    basicInfo: 'Basic Info',
    transportType: 'Transport Type',
    methodPaymentTaxes: 'Method payment',
    transactionType: 'Transaction type',
    locationOfGoods: 'Location of goods',
    deferredPayment: 'Deferred payment',
    customsBrokerInfo: "Customs broker's Info",
    eori: 'EORI',
    name: 'Name',
    phoneNumber: 'Phone number',
    consigneeInfo: 'Consignee Info',
    address: 'Address',
    consignorInfo: 'Consigner Info',
    taxRepresentativeInfo: 'Tax Representative Info',
    status: 'Status',
    receiverVAT: "Receiver's VAT",
    documentInfo: 'Document Info',
    supportingReferenceNumber: 'Supporting Reference number',
    supportingType: 'Supporting Type',
    previousReferenceNumber: 'Previous Reference number',
    previousType: 'Previous type',
    goodsInfo: 'Goods Info',
    referenceNumberURC: 'Reference number URC',
    totalGrossMass: 'Total Gross mass',
    totalValue: 'Total value',
    serialNumber: 'Serial number',
    hsCode: 'HS code',
    descriptionOfGoods: 'Description of goods',
    intrinsicValue: 'Intrinsic value',
    grossMass: 'Gross Mass',
    supplementaryUnits: 'Supplementary Units',
    quantity: 'Quantity',
    back: 'Back',
    email: 'Email address'
  },
  batch: {
    importData: 'Import Data',
    consignee: 'Consignor',
    hsQty: 'HS Qty',
    parcelQty: 'Parcel Qty',
    toDeclare: 'To declare',
    inProcess: 'In process',
    sent: 'Sent',
    release: 'Release',
    inControl: 'In Control',
    rejected: 'Rejected',
    actions: 'Actions',
    declare: 'Declare',
    delete: 'Delete',
    exportErrors: 'Export Errors',
    statusReport: 'Status Report',
    downloadManifest: 'Download Manifest',
    importErrors: 'Import Errors',
    confirm: 'Confirm',
    cancel: 'Cancel',
    areYouSureToDeclare: 'Are you sure to declare?',
    areYouSureToDelete: 'Are you sure to delete?',
    declareSuccessful: 'Declare successful',
    deleteSuccessful: 'Delete successful',
    clickToUpload: 'Click to upload files or drag files here',
    downloadTemplate: 'Download Import Template',
    gotIt: 'Got it',
    systemProcessing: 'System is processing the data...',
    waitUploadComplete: 'Please wait for the upload to complete.',
    closeIfUrgent: 'If you need to handle other urgent tasks, you may close this popup.',
    checkDocumentCenter: 'You can check the import result later in the Document Center.',
    uploadSuccessful: 'Upload is successful',
    uploadFailed: 'Upload is failed',
    verificationFailed: 'Notice: verification of data is failed.',
    clickDownloadOrShift: 'Click here',
    orShiftToImportTask: 'or Shift to Import Task in File Center at upper right download result file with error message.',
    checkErrorMessage: 'Check the Error Message at the last column of Result File, and modify the data in original template you tend to upload again.',
    reuploadAfterCorrect: 'Re-upload after all errors are corrected or removed.'
  },
  taskPane: {
    success: 'Success',
    failure: 'Failure',
    loading: 'Loading...',
    noMore: 'No more data'
  },
  user: {
    userName: 'User Name',
    createTime: 'Create Time',
    email: 'Email',
    userRole: 'User Role',
    status: 'Status',
    activated: 'Activated',
    disabled: 'Disabled',
    actions: 'Actions',
    role: 'Role',
    add: 'Add',
    save: 'Save',
    total: 'total',
    items: 'items',
    pleaseEnterUserName: 'Please enter user name',
    pleaseEnterEmail: 'Please enter email',
    pleaseEnterCorrectEmail: 'Please enter correct email',
    addUser: 'Add User',
    updateUser: 'Update User'
  },
  role: {
    roleName: 'Role Name',
    roleNumber: 'Role Number',
    createTime: 'Create Time',
    status: 'Status',
    activated: 'Activated',
    disabled: 'Disabled',
    roleDescription: 'Role Description',
    actions: 'Actions',
    add: 'Add',
    total: 'total',
    items: 'items',
    roleInformation: 'Role Information',
    functionalDescription: 'Functional Description',
    save: 'Save',
    back: 'Back',
    pleaseEnter: 'Please enter'
  },
  login: {
    welcome: 'Welcome to',
    platform: 'e-star Clearance Platform',
    enterDetails: 'Enter your details below',
    email: 'Email',
    password: 'Password',
    forgotPassword: 'Forgot Password',
    signIn: 'Sign In',
    register: 'Register',
    orConnectWith: 'Or connect with',
    capsLockOn: 'Caps lock is On',
    usernameRequired: 'Please enter the correct user name',
    passwordTooShort: 'The password can not be less than 6 digits'
  },
  register: {
    register: 'Register',
    welcomeRegister: 'Welcome register your e-Clearance account now',
    email: 'Email',
    pleaseEnterEmail: 'please enter email',
    verificationCode: 'Verification code',
    pleaseEnterCode: 'Please enter email verification code',
    send: 'Send',
    password: 'Password',
    pleaseEnterPassword: 'please enter password',
    confirmPassword: 'Confirm Password',
    pleaseEnterPasswordAgain: 'please enter password again',
    signIn: 'Sign In',
    emailRequired: 'Please enter email',
    emailInvalid: 'Please enter a valid email address',
    passwordRequired: 'Please enter password',
    passwordTooShort: 'The password can not be less than 6 digits',
    confirmPasswordRequired: 'please enter password again',
    passwordsMismatch: 'Two passwords that you enter is inconsistent!',
    enterEmailFirst: 'Please enter email first',
    verificationSent: 'Verification code sent successfully',
    verificationFailed: 'Failed to send verification code'
  },
  forgot: {
    welcomeReset: 'Welcome reset your password',
    email: 'Email',
    pleaseEnterEmail: 'please enter email',
    verificationCode: 'Verification code',
    pleaseEnterCode: 'Please enter email verification code',
    send: 'Send',
    password: 'Password',
    pleaseEnterPassword: 'please enter password',
    newPassword: 'New Password',
    pleaseEnterNewPassword: 'please enter new password',
    resetPassword: 'Reset Password',
    emailRequired: 'Please enter email',
    emailInvalid: 'Please enter a valid email address',
    passwordRequired: 'Please enter password',
    passwordTooShort: 'The password can not be less than 6 digits',
    newPasswordRequired: 'please enter new password',
    passwordsMismatch: 'Two passwords that you enter is inconsistent!',
    enterEmailFirst: 'Please enter email first',
    verificationSent: 'Verification code sent successfully',
    verificationFailed: 'Failed to send verification code'
  },
  navbar: {
    changePassword: 'Change Password',
    logout: 'Log Out',
    oldPassword: 'Old Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    pleaseEnterOldPassword: 'please enter old password',
    pleaseEnterNewPassword: 'please enter new password',
    pleaseConfirmNewPassword: 'please confirm new password',
    save: 'Save',
    cancel: 'Cancel',
    passwordRequired: 'Please enter password',
    newPasswordRequired: 'please enter new password',
    confirmPasswordRequired: 'Please confirm password',
    passwordTooShort: 'The password can not be less than 6 digits',
    passwordsMismatch: 'The two passwords do not match',
    changePasswordSuccess: 'Change password successfully',
    changePasswordFailed: 'Change password failed'
  },
  global: {
    enter: 'Please Enter',
    query: 'Query',
    reset: 'Reset',
    add: 'Add',
    total: 'total',
    item: 'items',
    action: 'Actions',
    status: 'Status',
    startDate: 'Start Date',
    endDate: 'End Date'
  },
  enterprise: {
    companyNameLabel: 'Company name',
    statusLabel: 'Status',
    submissionTimeLabel: 'Submission Time',
    companyName: 'Company name',
    contactName: 'Contact name',
    globalVatNo: 'Global VAT No.',
    eori: 'EORI',
    submissionTime: 'Submission Time',
    reviewTime: 'Review Time',
    approve: 'Approve',
    reject: 'Reject',
    confirmApprove: 'Are you sure to approve?',
    rejectionsReason: 'Reason for Rejection',
    inputReason: 'Please input reason',
    submitSuccess: 'Submit success!',
    pendingStatus: 'Pending',
    submittedStatus: 'Submitted',
    approvedStatus: 'Approved',
    rejectedStatus: 'Rejected',
    verificationRequired: 'Please complete your company verification first. Access will be granted after approval.',
    rejectedTip: 'Company filing review was not approved. Reason: {remark}. Please update the information and resubmit.',
    submittedTip: 'Company filing has been submitted and is under review. Please wait patiently.',
    approvedTip: 'Company filing has been approved. All system features are now available.',
    companyInfo: 'Company Information',
    companyAddress: 'Company address',
    incorporationDate: 'Date of Incorporation',
    contactInfo: 'Contact Information',
    email: 'Email',
    phoneNumber: 'Phone number',
    taxInfo: 'Tax Information',
    remarks: 'Remarks',
    paymentInfo: 'Payment Information',
    paymentType: 'Payment Type',
    paymentMethodA: 'A',
    paymentMethodE: 'E',
    paymentMethodP: 'P',
    paymentMethodBankTransfer: 'Bank Transfer',
    paymentMethodCreditCard: 'Credit Card',
    paymentMethodSepa: 'SEPA',
    pleaseSelect: 'Please select',
    paymentRefNumber: 'Payment Reference number',
    defaultFlag: 'Default flag',
    add: '+ Add',
    delete: 'delete',
    edit: 'Edit',
    cancel: 'Cancel',
    locationInfo: 'Location Information',
    locationName: 'Location Name',
    locationCode: 'Location code',
    submit: 'Submit',
    emailCorrect: 'Please enter the correct email',
    submitSuccessful: 'Submit successful',
    submitFailed: 'Submit failed',
    submitFailedMsg: 'Submit failed: ',
    unknownError: 'Unknown error',
    completeFields: 'Please complete all required fields',
    paymentTypeRow: 'Please select payment type for row ',
    paymentRefRow: 'Please enter payment reference number for row ',
    oneDefaultRequired: 'At least one payment method must be set as default',
    locationNameRow: 'Please enter location name for row ',
    locationCodeRow: 'Please enter location code for row '
  },
  menu: {
    menuList: 'Menu List',
    addMenu: 'Add Menu',
    menuEdit: 'Menu Edit',
    menuName: 'Menu Name',
    pleaseEnterMenuName: 'Please enter menu name',
    languageKey: 'Multi-language Name',
    pleaseEnterMultiLanguageFormat: 'Please enter the following format, e.g.: $tr("submit", "Submit")',
    menuType: 'Menu Type',
    directory: 'Directory',
    menu: 'Menu',
    permission: 'Permission',
    portal: 'Portal',
    routePath: 'Route Path',
    pleaseEnterRoutePath: 'Please enter route path',
    pleaseEnterPermission: 'Please enter permission',
    parentMenu: 'Parent Menu',
    pleaseSelectParentMenu: 'Please select parent menu',
    none: 'None',
    displayOrder: 'Display Order',
    pleaseEnterOrderNumber: 'Please enter order number',
    menuIcon: 'Menu Icon',
    pleaseEnterMenuIcon: 'Please enter menu icon',
    visible: 'Visible',
    show: 'Show',
    hide: 'Hide',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    pleaseSelectMenuToEdit: 'Please select a menu from the left to edit',
    createMenu: 'Create Menu',
    confirm: 'Confirm',
    pleaseEnterUserName: 'Please enter user name',
    pleaseSelectMenuType: 'Please select menu type',
    pleaseSelectParentMenuFirst: 'Permission must select parent menu',
    updateSuccess: 'Update successful',
    confirmDelete: 'Are you sure to delete this menu?',
    prompt: 'Prompt',
    deleteSuccess: 'Delete successful',
    addSuccess: 'Add successful'
  }
}
